export default "__VITE_ASSET__$0UTZY2x__"